var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditDone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "EditDone_svg__a",
  width: 14,
  height: 14,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h14v14H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#EditDone_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m5.556 10.5 6.184-6.183-.832-.817-5.366 5.352-2.465-2.48-.831.832zm-.831.817L1.429 8.02a1.1 1.1 0 0 1-.255-.387 1.2 1.2 0 0 1 0-.867q.08-.22.255-.394l.817-.817q.174-.175.386-.262t.445-.088a1.15 1.15 0 0 1 .831.35l1.648 1.648 4.521-4.535a.95.95 0 0 1 .38-.256q.217-.08.437-.08.219 0 .437.08.219.08.394.241l.831.817q.175.174.263.386.087.212.087.445 0 .234-.08.445t-.255.386l-6.183 6.184a1.171 1.171 0 0 1-.831.35 1.17 1.17 0 0 1-.832-.35"
}))));
export default SvgEditDone;